<template>
    <el-dialog
        width="600px"
        :visible="visible"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose">
        <template slot="title">
            <div><span class="dialog-header">{{dispatchNo}}</span>运输成本修改日志</div>
        </template>
        <section class="dispatchOrder-table">
            <table-box
                ref="tablePage"
                :columns="config.table.columns"
                :height="config.table.height"
                :loading="loading"
                :rows="transportationList"
            >
            </table-box>
            <m-page
                :current-page="page.pageNo"
                :pageData="config.page"
                :total="pageTotal"
                @on-page-change="pageChange"
                @on-size-change="sizeChange"
                class="page-container"
            ></m-page>
        </section>
    </el-dialog>
</template>

<script>
import tableBox from '@/components/lots/tableBox/Index.vue';
import mPage from '@/components/otpPanel/mPage';
import config from './config.js';
import { queryRecord } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
export default {
    name: 'TransportationCostLog',
    components: {
        tableBox,
        mPage
    },
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            loading: false,
            visible: false,
            dispatchNo: '',
            transportationList: [],
            pageTotal: 0,
            config: config,
            page: {
                pageSize: 10,
                pageNo: 1
            }
        };
    },
    mounted () {
        this.visible = true;
        this.dispatchNo = this.componentsData.dispatchNo;
        this.queryRecord();
    },
    methods: {
        // 关闭
        beforeClose () {
            this.$emit('components-close');
        },
        /**
         * @description 查询运费修改日志
         */
        queryRecord () {
            queryRecord(this.getParams()).then(res => {
                if (res && +res.code === 0) {
                    this.transportationList = this.formatData(res.data.list || []);
                    this.pageTotal = res.data.totalCount;
                }
            });
        },
        /**
         * @description 处理列表数据
         */
        formatData (data) {
            if (!data.length) return [];
            data.forEach((item, index) => {
                item.index = index + 1;
                item.content = `运输成本由${item.beforeTransportationCost}修改为${item.afterTransportationCost}`;
            });
            return data;
        },
        /**
         * @description 组装查询参数
         */
        getParams () {
            const params = {
                param: {
                    dispatchNo: this.dispatchNo
                },
                pageNo: 1,
                ...this.page
            };
            return params;
        },
        // 页数改变
        sizeChange (data) {
            this.page.pageSize = data;
            this.page.pageNo = 1;
            this.queryRecord();
        },
        // 切分页
        pageChange (data) {
            this.page.pageNo = data;
            this.queryRecord();
        },
        actionClick() {}
    }
};
</script>

<style lang="less" scoped>
.dialog-header {
    display: inline-block;
    margin-right: 8px;
    font-size: 17px;
    color: #00bcbf;
}
// /deep/ .el-dialog {
//     height: 300px;
// }
// .page-container {
//     position: absolute;
//     right: 0px;
//     bottom: 10px;
// }
</style>
